import React, { useEffect } from 'react'

import { useRouteError } from 'react-router-dom'

import { PageHeader } from 'mailup-web-components'

import { logAppError } from 'Helpers/logger'

const ErrorBoundaryReactRouterV6 = (props) => {
  const error = useRouteError()

  useEffect(() => {
    if (error !== undefined) {
      logAppError({
        appError: error,
      })
    }
  }, [error])

  return <PageHeader breadcrumbsItems={[]} />
}

export default ErrorBoundaryReactRouterV6
